export function formatLocalDate(date: string) {
  if (!date) return '';

  const newDate = new Date(date);

  if (isNaN(newDate.getTime())) return '';

  const month = String(newDate.getMonth() + 1).padStart(2, '0');
  const day = String(newDate.getDate()).padStart(2, '0');
  const year = newDate.getFullYear();

  return `${month}/${day}/${year}`; // MM/DD/YYYY
}

export function formatDateYYYYMMDD(date: string) {
  if (!date) return '';

  const newDate = new Date(date);

  if (isNaN(newDate.getTime())) return '';

  const month = String(newDate.getMonth() + 1).padStart(2, '0');
  const day = String(newDate.getDate()).padStart(2, '0');
  const year = newDate.getFullYear();

  return `${year}-${month}-${day}`; // YYYY-MM-DD
}





export function formatLocalTime(date: string) {
  const newDate = new Date(date);

  // Sirf HH:MM 24-hour format
  const formattedTime = newDate.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit'
  });

  return formattedTime;
}

